import { render, staticRenderFns } from "./NbIotLink.vue?vue&type=template&id=19c818ac&scoped=true&"
import script from "./NbIotLink.vue?vue&type=script&lang=js&"
export * from "./NbIotLink.vue?vue&type=script&lang=js&"
import style0 from "./NbIotLink.vue?vue&type=style&index=0&id=19c818ac&prod&lang=scss&scoped=true&"
import style1 from "./NbIotLink.vue?vue&type=style&index=1&id=19c818ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c818ac",
  null
  
)

export default component.exports